import { createTheme } from '@mui/material/styles';

// ACT brand tokens, taken from the All City Towing logo (navy + red).
export const tokens = {
    navy: '#102A4C',
    navyLight: '#1A3A63',
    blue: '#1F4E8C',
    red: '#C8202F',
    workspace: '#F3F5F8',
    surface: '#FFFFFF',
    line: '#DCE1E8',
    text: '#1B2533',
    muted: '#5B6778',
    sidebarText: '#C9D3E1',
};

export const HEADING_FONT = '"Barlow Semi Condensed", "Arial Narrow", sans-serif';
export const BODY_FONT = '"IBM Plex Sans", "Segoe UI", Roboto, Arial, sans-serif';

const theme = createTheme({
    palette: {
        primary: { main: tokens.blue, dark: tokens.navy, contrastText: '#FFFFFF' },
        secondary: { main: tokens.red, contrastText: '#FFFFFF' },
        error: { main: '#B42318' },
        warning: { main: '#B7791F' },
        success: { main: '#2E7D32' },
        info: { main: '#2F6FB2' },
        background: { default: tokens.workspace, paper: tokens.surface },
        text: { primary: tokens.text, secondary: tokens.muted },
        divider: tokens.line,
    },
    shape: { borderRadius: 6 },
    typography: {
        fontFamily: BODY_FONT,
        fontSize: 14,
        h1: { fontFamily: HEADING_FONT, fontWeight: 600, fontSize: '2rem', letterSpacing: 0.2 },
        h2: { fontFamily: HEADING_FONT, fontWeight: 600, fontSize: '1.75rem' },
        h3: { fontFamily: HEADING_FONT, fontWeight: 600, fontSize: '1.5rem' },
        h4: { fontFamily: HEADING_FONT, fontWeight: 600, fontSize: '1.375rem' },
        h5: { fontFamily: HEADING_FONT, fontWeight: 600, fontSize: '1.25rem' },
        h6: { fontFamily: HEADING_FONT, fontWeight: 600, fontSize: '1.0625rem' },
        subtitle1: { fontWeight: 500 },
        button: { fontWeight: 600, textTransform: 'none', letterSpacing: 0.2 },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: { backgroundColor: tokens.workspace, color: tokens.text },
                a: { color: tokens.blue },
            },
        },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: { root: { borderRadius: 6, paddingInline: 16 } },
        },
        MuiPaper: {
            defaultProps: { elevation: 0 },
            styleOverrides: { outlined: { borderColor: tokens.line } },
        },
        MuiCard: {
            defaultProps: { variant: 'outlined' },
        },
        MuiTextField: {
            defaultProps: { size: 'small', variant: 'outlined' },
        },
        MuiFormControl: {
            defaultProps: { size: 'small' },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: { backgroundColor: tokens.surface },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 600,
                    color: tokens.muted,
                    backgroundColor: '#F7F9FB',
                    borderBottom: `1px solid ${tokens.line}`,
                    whiteSpace: 'nowrap',
                },
                root: { borderBottom: `1px solid ${tokens.line}` },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: { '&.MuiTableRow-hover:hover': { backgroundColor: '#F2F6FB' } },
            },
        },
        MuiChip: {
            styleOverrides: { root: { fontWeight: 500 } },
        },
    },
});

export default theme;
